import { React, useEffect, useState, useRef } from "react";
import logo from "./img/edaplogo.png";
import "./search.css";
import { Search, Download, Eye, EyeOff, ArrowLeft, Delete } from "react-feather";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import signature from "./img/signature.png";
import html2pdf from "html2pdf.js";
import { getDatabase, ref, onValue } from "firebase/database";
import axios from "axios";

const Student_Card = ({ student, onDelete }) => {
  const handleDownload = () => {
    const cardElement = document.querySelector(".card");
    html2canvas(cardElement, {
      width: 550,
      backgroundColor: "black",
      scale: 1,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = `${student.Names.replace(/\s+/g, "_")}_Student_Card.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  return (
    <div>
      <div className="card">
        <div className="heading">
          <img src={logo} alt="University Logo" className="logo" />
          <div className="university-info">
            <h2>UNIVERSITY OF LISALA</h2>
            <p style={{ textTransform: "uppercase", fontWeight: "bolder" }}>
              Centre INTERUNIVERSITAIRE de Recherche Pluridisciplinaire
              <br />
              <strong>CIREP</strong>
            </p>
          </div>
        </div>
        <div className="student-section">
          <h3>STUDENT CARD</h3>
          <div className="student-info">
            <div className="photo-container">
              <img
                src={student.image || require("./carte etudiant/img/icon.jpg")}
                alt={`Student ${student.Names}`}
                className="photo"
              />
            </div>
            <div className="details">
              <p><strong>Names:</strong> {student.Names}</p>
              <p><strong>Faculty:</strong> {student.Faculty}</p>
              <p><strong>Department:</strong> {student.Department}</p>
              <p>
                <strong>Class:</strong> {student.Class} , <strong>Matricule:</strong> {student.Matricule}
              </p>
              <p><strong>Academic Year:</strong> {student["Academic year"]}</p>
            </div>
          </div>
        </div>
        <div className="footer">
          <strong style={{ marginLeft: 50, fontSize: 11 }}>
            Web: www.cirep.ac.cd | E-mail: info@cirep.ac.ad
          </strong>
        </div>
      </div>
      <div className="crud">
        <button className="download-button" onClick={() => onDelete(student)}>
          Supprimer <Delete style={{ margin: "1px 0 -2px 10px" }} size={15} />
        </button>
        <button className="download-button" onClick={handleDownload}>
          Telecharger <Download style={{ margin: "1px 0 -2px 10px" }} size={15} />
        </button>
      </div>
    </div>
  );
};

const Receipt_Template = ({ formData }) => {
    const now = new Date().toLocaleDateString();
    const qrCodeRef = useRef();

    useEffect(() => {
      const generateQRCode = async () => {
        const qrData = `
          Name: ${formData.Names}
          Faculty: ${formData.Faculty}
          Department: ${formData.Department}
          Class: ${formData.Class}
          Matricule: ${formData.Matricule}
          Amount: ${formData.Amount}
          Reason: ${formData.reason}
          Date: ${formData.date}
          Ref: ${formData.ref}
          Verification: Receipt Confirmed
        `;
        const qrCodeUrl = await QRCode.toDataURL(qrData);
        qrCodeRef.current.src = qrCodeUrl;
      };
      generateQRCode();
    }, [formData]);

    return (
      <div>
        <div className="recu-body" id={`receipt-${formData.Names}`}>
          <div className="school-pic">
            <div className="frecu">
              <h3>Universite de Lisala</h3>
              <img src={logo} alt="University Logo" />
              <p>
                Centre Interuniversitaire de Recherche Pluridisciplinaire (CIREP)
                <br />
                <span>
                  <strong>Status :</strong> Université publique
                  <br />
                  <strong>Web :</strong> cirep.ac.ad
                  <br />
                  <strong>Email :</strong> info@cirep.ac.ad
                </span>
              </p>
            </div>
            {formData.image && (
              <img src={formData.image} alt="Student" className="stu-pic" />
            )}
          </div>
          <p className="stup">
            Reçu de : <strong>{formData.Names} </strong>
            le somme de: <strong>{formData.Amount} </strong>
            versée le <strong>{formData.date} </strong><br /> pour :{" "}
            <strong>{formData.reason} </strong>  à :{" "}
            <strong>{formData.source}</strong> N°/Ref <strong>{formData.ref}</strong>{" "}
            <br />a été
            vérifiée et confirmée par le service de comptabilité du CIREP le :{" "}
            <strong>{now}</strong>
            <br />
            <br />
            <br />
            <div style={{display: "flex", marginBottom: "-15px"} }>
              <div>
                <span><b>Signature:</b></span>
              </div>
              <div>
                <img src={signature} width={100}/>
              </div>
            </div>
              <span style={{marginTop: "-35px"}}>
                Nelly Merveille
                <br />
                Secrétaire-Comptable-Logistique du CIREP
              </span>
          </p>
          <div className="qr-container">
            <img ref={qrCodeRef} alt="QR Code" className="qr-code" />
          </div>
        </div>
        <button
              className="download-button"
              onClick={() => downloadPDF(formData.Names)}
            >
             Telecharger <Download size={15} />
            </button>
      </div>
    );
  };


  function SearchDoc() {
    const [fileList, setFileList] = useState([]);
    const [studentsData, setStudentsData] = useState(null);
    const [receiptsData, setReceiptsData] = useState(null);
    const [transcriptsData, setTranscriptsData] = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const [searchMatricule, setSearchMatricule] = useState('');
    const [isSearchClicked, setIsSearchClicked] = useState(false);
    const [selectedResult, setSelectedResult] = useState(null);
    const searchInputRef = useRef();

    useEffect(() => {
      const db = getDatabase();
      const studentsRef = ref(db, 'students/UND/');
      const receiptsRef = ref(db, 'receipts/UND/');
      const transcriptsRef = ref(db, 'transcripts/UND/');

      onValue(studentsRef, (snapshot) => {
        const data = snapshot.val();
        setStudentsData(data ? Object.values(data) : []);
      });

      onValue(receiptsRef, (snapshot) => {
        const data = snapshot.val();
        setReceiptsData(data ? Object.values(data) : []);
      });

      onValue(transcriptsRef, (snapshot) => {
        const data = snapshot.val();
        setTranscriptsData(data ? Object.values(data) : []);
      });
    }, []);

    const handleSearchChange = (e) => {
      setSearchMatricule(e.target.value);
    };

    const fetchFileList = async () => {
      try {
        const response = await axios.get('http://localhost:5000/files', {
          params: { matricule: searchMatricule },
        });
        setFileList(response.data);
      } catch (err) {
        console.error('Error fetching file list:', err);
      }
    };

    const handleDocumentSearch = () => {
      const searchTerm = searchInputRef.current.value.trim().toLowerCase();  // Get search term and remove extra spaces

      if (searchTerm === '') {
        setSearchResults([]);
        return;
      }
      const results = [];
      if (studentsData) {
        results.push(
          ...studentsData.filter((student) =>
            student.Matricule.toLowerCase() === searchTerm
          )
        );
      }
      if (receiptsData) {
        results.push(
          ...receiptsData.filter((receipt) =>
            receipt.Matricule.toLowerCase() === searchTerm
          )
        );
      }
      if (transcriptsData) {
        results.push(
          ...transcriptsData.filter((transcript) =>
            transcript.matriculationNumber.toLowerCase() === searchTerm
          )
        );
      }

      setSearchResults(results);
      setSelectedResult(null);
    };

    const handleSearchClick = () => {
      setIsSearchClicked(true);
      fetchFileList();
      handleDocumentSearch();
    };

    useEffect(() => {
      if (!isSearchClicked) {
        setFileList([]);
        setSearchResults([]);
      }
    }, [isSearchClicked]);

    // View selected result details
    const handleViewCard = (result) => {
      setSelectedResult(result);
    };

    const handleDeleteResult = (resultToDelete) => {
      setSearchResults((prevResults) =>
        prevResults.filter((result) => result !== resultToDelete)
      );
      setSelectedResult(null);
    };

    return (
      <div className="search-page">
        <div className="search-form">
          <div className="srch-txt">
            <img src={logo} alt="Logo" />
            <br />
            <span id="in">
              Bienvenue sur la page de Recherche des documents, en entrant votre matricule vous pouvez facilement trouver et télécharger vos
              documents.
            </span>
            <span id="out">
              <br/>
              Bienvenue Cher(é) Etudiant, en entrant votre matricule vous pouvez facilement trouver et télécharger vos documents.
            </span>
          </div>
  
          <div className="search-in">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Entrez votre matricule"
              onChange={handleSearchChange}
            />
            <button className="search-btn" onClick={handleSearchClick}>
              <Search />
            </button>
          </div>
        </div>
  
        <div className="search-results">
          {isSearchClicked && (
            <>
              {selectedResult === null ? (
                searchResults.length === 0 && fileList.length === 0 ? (
                  <p>Pas de Documents sous ce Matricule.</p>
                ) : (
                  <>
                    {searchResults.length > 0 && (
                      <ul>
                        {searchResults.map((result, index) => (
                          <li key={index}>
                            <button
                              className="srch-button"
                              onClick={() => handleViewCard(result)}
                            >
                              {result.Amount
                                ? 'Reçu de paiement'
                                : result.transcript
                                ? 'Relevé de Notes'
                                : 'Carte Etudiant'}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}

                    {fileList.length > 0 && (
                      <ul>
                        {fileList.map((filename) => {
                          const fileNameWithoutMatricule = filename.split('-').slice(1).join('-');
                          return (
                            <li key={filename}>
                              <a href={`http://localhost:5000/download/${filename}`} target="_blank" rel="noopener noreferrer">
                                <button className="download-button">
                                  {fileNameWithoutMatricule}
                                </button>
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </>
                )
              ) : selectedResult.Amount ? (
                <div>
                  <button className="download-button" onClick={() => setSelectedResult(null)}>
                    &larr; Retour
                  </button>
                  <Receipt_Template formData={selectedResult} />
                </div>
              ) : selectedResult.transcript ? (
                <div>
                  <button className="download-button" onClick={() => setSelectedResult(null)}>
                    &larr; Retour
                  </button>
                  <br />
                  <br />
                  <div dangerouslySetInnerHTML={{ __html: selectedResult.transcript }} />
                  <br />
                  <button
                    className="download-button"
                    onClick={() =>
                      handleDownloadTranscript(
                        selectedResult.transcript,
                        selectedResult.matriculationNumber || 'transcript'
                      )
                    }
                  >
                    Télécharger <Download size={15} />
                  </button>
                </div>
              ) : (
                <div>
                  <button className="download-button" onClick={() => setSelectedResult(null)}>
                    &larr; Retour
                  </button>
                  <Student_Card student={selectedResult} onDelete={handleDeleteResult} />
                </div>
              )}
            </>
          )}
        </div>

      </div>
    );
  }

  const downloadPDF = (name) => {
    const element = document.getElementById(`receipt-${name}`);
    const options = {
      margin: 1,
      filename: `${name}_receipt.pdf`,
      html2canvas: { scale: 2, x: -2, y: 0, backgroundColor: 'none' },
      jsPDF: { format: 'a4', orientation: 'portrait' },
    };
    html2pdf().set(options).from(element).save();
  };

  const handleDownloadTranscript = (transcript, studentName) => {
    const container = document.createElement('div');
    container.innerHTML = transcript;
    document.body.appendChild(container);

    const options = {
      filename: `${studentName}_transcript.pdf`,
      html2canvas: { x: -30, y: -20, scale: 2, width: 900 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    html2pdf().set(options).from(container).save().finally(() => {
      document.body.removeChild(container);
    });
  };

  export default SearchDoc;